module.exports = require("@pandora/data-model-product");